import { documentNumberApi } from "@/getinfo-api/index";

export interface DocumentNumberingListParams {
  companyId: string;
  title?: string;
  type?:
    | "all"
    | "unset"
    | "contract"
    | "act"
    | "bill"
    | "learning_request"
    | "final_document"
    | "education_protocol"
    | "enrollment_order"
    | "expulsion_order";
  offset?: number;
  limit?: number;
  sort?: "type" | "title";
  order?: "ASC" | "DESC";
  options?: any;
}

export default (params: DocumentNumberingListParams) => {
  return documentNumberApi.listSequences(
    params.companyId,
    params.title,
    params.type,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    params.options
  );
};
